/* MC productsecties — filters, Toon meer, swipe-rij en feedback bij toevoegen. */
(function () {
  if (window.__mcpInit) return;
  window.__mcpInit = true;

  var CAP = 20;          // daarna verwijzen we naar de collectie
  var STEP = 6;          // per klik op Toon meer
  var MOBILE_N = { grid: 8, bento: 6, tabs: 6 }; // aantal bij openen op mobiel
  var cache = {};

  function feedUrl(url) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=mc-products-feed';
  }

  function getFeed(url) {
    if (!cache[url]) {
      cache[url] = fetch(feedUrl(url), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var feed = doc.querySelector('[data-mcp-feed]');
          var fj = doc.querySelector('[data-mcp-facets-json]');
          var facets = null;
          if (fj) { try { facets = JSON.parse(fj.textContent); } catch (e) { facets = null; } }
          return {
            facets: facets,
            total: feed ? parseInt(feed.getAttribute('data-total'), 10) || 0 : 0,
            cards: feed ? Array.prototype.slice.call(feed.querySelectorAll('[data-mcp-card]')) : []
          };
        })
        .catch(function (e) { delete cache[url]; throw e; });
    }
    return cache[url];
  }

  function fmt(tpl, n, s) {
    return (tpl || '').replace('%n', n).replace('%s', s);
  }

  function initSection(sec) {
    if (sec.__mcp) return;
    sec.__mcp = true;
    var layout = sec.getAttribute('data-layout');
    var initial = parseInt(sec.getAttribute('data-initial'), 10) || 8;
    var loadMode = sec.getAttribute('data-load');
    var grid = sec.querySelector('[data-mcp-grid]');
    var loadBtn = sec.querySelector('[data-mcp-load]');
    var all2 = sec.querySelector('[data-mcp-all2]');
    var status = sec.querySelector('[data-mcp-status]');
    var tAll = sec.getAttribute('data-t-all');
    var tSeen = sec.getAttribute('data-t-seen');
    var isMobile = window.matchMedia('(max-width: 749px)');

    var firstBtn = sec.querySelector('[data-mcp-filter].is-on') || sec.querySelector('[data-mcp-filter]');
    var state = {
      url: firstBtn ? firstBtn.getAttribute('data-url') : null,
      total: firstBtn ? parseInt(firstBtn.getAttribute('data-total'), 10) || 0 : 0,
      pool: null,      // nog niet getoonde kaarten uit de feed
      exhausted: false
    };
    if (!state.url) {
      var allA = sec.querySelector('[data-mcp-all]');
      state.url = allA ? allA.getAttribute('href') : null;
    }
    if (!state.total) {
      var n = sec.querySelector('[data-mcp-n]');
      if (n) state.total = parseInt(n.textContent, 10) || 0;
    }

    // Sfeerfoto wisselen bij een filter met eigen foto (bijv. per geur). Laadt pas bij klik.
    var photo = sec.querySelector('.mcp-grid .mcp-photo--big, .mcp-grid .mcp-photo--big2');
    var orig = null;
    function swapPhoto(btn) {
      if (!photo) return;
      var img = photo.querySelector('.mcp-photo__img img');
      var tag = photo.querySelector('.mcp-photo__tag');
      var t = photo.querySelector('.mcp-photo__t');
      var bt = photo.querySelector('.mcp-photo__btn');
      var a = photo.matches('a') ? photo : photo.querySelector('.mcp-photo__a');
      if (!orig) orig = {
        src: img && img.getAttribute('src'), srcset: img && img.getAttribute('srcset'),
        tag: tag && tag.textContent, t: t && t.textContent, bt: bt && bt.textContent, href: a && a.getAttribute('href')
      };
      var u = btn.getAttribute('data-img');
      if (!u) {
        if (!photo.classList.contains('is-scent')) return;
        photo.classList.remove('is-scent');
        if (img) { img.setAttribute('srcset', orig.srcset || ''); img.setAttribute('src', orig.src); }
        if (tag) tag.textContent = orig.tag; if (t) t.textContent = orig.t; if (bt) bt.textContent = orig.bt;
        if (a) a.setAttribute('href', orig.href);
        return;
      }
      var set = [400, 600, 800, 1100].map(function (w) { return u.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w'; }).join(', ');
      photo.classList.add('is-scent', 'is-swapping');
      if (img) {
        img.onload = function () { photo.classList.remove('is-swapping'); };
        img.setAttribute('srcset', set); img.setAttribute('src', u.replace(/width=\d+/, 'width=800'));
      }
      var label = btn.getAttribute('data-label') || '';
      if (tag) tag.textContent = label;
      if (t) t.textContent = btn.getAttribute('data-notes') || label;
      if (bt) bt.textContent = fmt(sec.getAttribute('data-t-view'), '', label);
      if (a) a.setAttribute('href', btn.getAttribute('data-img-link') || btn.getAttribute('data-url'));
      setTimeout(function () { photo.classList.remove('is-swapping'); }, 1200);
    }

    function cards() { return grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-mcp-card]')) : []; }
    function visibleCount() { return cards().filter(function (c) { return !c.hidden; }).length; }

    function insertCard(card) {
      var anchor = grid.querySelector('.mcp-note, [data-mcp-count]');
      grid.insertBefore(card, anchor);
    }

    function updateFoot() {
      if (!grid || !loadBtn) return;
      var shown = visibleCount();
      var hiddenLocal = cards().some(function (c) { return c.hidden; });
      var total = state.total || shown;
      var canMore;
      if (loadMode === 'mobile') {
        canMore = isMobile.matches && hiddenLocal;
      } else {
        canMore = hiddenLocal || (shown < Math.min(total, CAP) && !state.exhausted);
      }
      loadBtn.hidden = !canMore;
      if (all2) {
        all2.hidden = canMore || shown >= total || loadMode === 'mobile';
        all2.firstChild.nodeValue = fmt(tAll, total, '');
      }
      if (status) status.textContent = total > shown ? fmt(tSeen, total, shown) : '';
    }

    function setAllLinks(url, total) {
      sec.querySelectorAll('[data-mcp-all], [data-mcp-all2], [data-mcp-count]').forEach(function (a) {
        a.setAttribute('href', url);
      });
      sec.querySelectorAll('[data-mcp-all]').forEach(function (a) {
        if (a.firstChild && a.firstChild.nodeType === 3) a.firstChild.nodeValue = fmt(tAll, total, '');
      });
      var n = sec.querySelector('[data-mcp-n]');
      if (n) n.textContent = total;
    }

    function clipMobile() {
      var lim = MOBILE_N[layout];
      if (!lim || !grid) return;
      cards().forEach(function (c, i) {
        if (isMobile.matches && i >= lim && !c.hidden) { c.hidden = true; c.setAttribute('data-mcp-clip', ''); }
        else if (!isMobile.matches && (loadMode === 'mobile' || c.hasAttribute('data-mcp-clip'))) { c.hidden = false; c.removeAttribute('data-mcp-clip'); }
      });
      updateFoot();
    }

    // Filters / tabs / keuze
    sec.querySelectorAll('[data-mcp-filter]').forEach(function (btn) {
      var url = btn.getAttribute('data-url');
      btn.addEventListener('pointerenter', function () {
        getFeed(url).catch(function () {});
        var u = btn.getAttribute('data-img'); if (u) { var im = new Image(); im.src = u.replace(/width=\d+/, 'width=800'); }
      }, { once: true });
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-on') || !grid) return;
        sec.querySelectorAll('[data-mcp-filter]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        swapPhoto(btn);
        var intro = sec.querySelector('[data-mcp-intro]');
        if (intro) intro.textContent = btn.getAttribute('data-text') || '';
        var tabtext = sec.querySelector('[data-mcp-tabtext]');
        if (tabtext && btn.getAttribute('data-text')) tabtext.textContent = btn.getAttribute('data-text');
        grid.setAttribute('aria-busy', 'true');
        state.url = url;
        getFeed(url).then(function (data) {
          if (state.url !== url) return; // er is intussen op een ander filter geklikt
          var total = parseInt(btn.getAttribute('data-total'), 10) || data.total || data.cards.length;
          state.total = total;
          state.exhausted = data.cards.length <= initial;
          cards().forEach(function (c) { c.remove(); });
          var list = data.cards.map(function (c) { return document.importNode(c, true); });
          list.slice(0, initial).forEach(insertCard);
          state.pool = list.slice(initial);
          setAllLinks(btn.getAttribute('data-all') || url, total);
          grid.removeAttribute('aria-busy');
          clipMobile();
          updateFoot();
        }).catch(function () {
          window.location.href = btn.getAttribute('data-all') || url;
        });
      });
    });

    // Filters zoals op de collectiepagina (uitklapknoppen). Laden pas als de sectie bijna in beeld is.
    var fbox = sec.querySelector('[data-mcp-facets]');
    if (fbox && grid) initFacets();

    function initFacets() {
      var base = sec.getAttribute('data-facets');
      var bar = fbox.querySelector('[data-mcp-facets-bar]');
      var panel = fbox.querySelector('[data-mcp-facets-panel]');
      var activeBox = fbox.querySelector('[data-mcp-facets-active]');
      var T = function (k) { return sec.getAttribute('data-t-' + k) || ''; };
      var cur = sec.getAttribute('data-cur') || '€';
      var sel = {};        // param -> [waarden]
      var price = {};      // param -> waarde
      var facets = [];
      var openIdx = -1;
      var req = 0;

      function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

      function query() {
        var q = [];
        Object.keys(sel).forEach(function (p) { sel[p].forEach(function (v) { q.push(encodeURIComponent(p) + '=' + encodeURIComponent(v)); }); });
        Object.keys(price).forEach(function (p) { if (price[p] !== '' && price[p] != null) q.push(encodeURIComponent(p) + '=' + encodeURIComponent(price[p])); });
        return q.join('&');
      }
      function urlFor() { var q = query(); return q ? base + (base.indexOf('?') > -1 ? '&' : '?') + q : base; }

      function syncFrom(list) {
        facets = (list || []).filter(function (f) {
          if (f.type === 'price') return f.range_max > 1;
          return f.values && f.values.some(function (v) { return v.count > 0 || v.active; });
        });
        sel = {}; price = {};
        facets.forEach(function (f) {
          if (f.type === 'price') {
            if (f.min.value != null) price[f.min.param] = f.min.value;
            if (f.max.value != null) price[f.max.param] = f.max.value;
          } else {
            f.values.forEach(function (v) { if (v.active) (sel[f.param] = sel[f.param] || []).push(v.value); });
          }
        });
      }

      function nActive(f) {
        if (f.type === 'price') return (f.min.value != null || f.max.value != null) ? 1 : 0;
        return f.values.filter(function (v) { return v.active; }).length;
      }

      function renderBar() {
        bar.removeAttribute('aria-busy');
        bar.innerHTML = facets.map(function (f, i) {
          var n = nActive(f);
          return '<button type="button" class="mcp-chip mcp-fbtn' + (n ? ' is-set' : '') + (i === openIdx ? ' is-open' : '') + '" aria-expanded="' + (i === openIdx) + '" data-i="' + i + '">' +
            '<span class="mcp-chip__l">' + esc(f.label) + '</span>' + (n ? ' <small>' + n + '</small>' : '') +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg></button>';
        }).join('');
        var chips = [];
        facets.forEach(function (f) {
          if (f.type === 'price') {
            if (f.min.value != null || f.max.value != null) {
              chips.push('<button type="button" class="mcp-fchip" data-clear-price="1" aria-label="' + esc(T('remove')) + '">' + esc(f.label) + ': ' + cur + (f.min.value != null ? f.min.value : 0) + ' – ' + cur + (f.max.value != null ? f.max.value : f.range_max) + ' <span aria-hidden="true">×</span></button>');
            }
          } else {
            f.values.forEach(function (v) {
              if (v.active) chips.push('<button type="button" class="mcp-fchip" data-p="' + esc(f.param) + '" data-v="' + esc(v.value) + '" aria-label="' + esc(T('remove') + ': ' + v.label) + '">' + esc(v.label) + ' <span aria-hidden="true">×</span></button>');
            });
          }
        });
        if (chips.length) chips.push('<button type="button" class="mcp-fclear" data-clear-all>' + esc(T('clear')) + '</button>');
        activeBox.innerHTML = chips.join('');
        activeBox.hidden = !chips.length;
      }

      function renderPanel() {
        var f = facets[openIdx];
        if (!f) { panel.hidden = true; panel.innerHTML = ''; return; }
        var html;
        if (f.type === 'price') {
          html = '<form class="mcp-fprice" data-price>' +
            '<label><span>' + esc(T('from')) + '</span><span class="mcp-fprice__in">' + esc(cur) + '<input type="number" inputmode="numeric" min="0" max="' + f.range_max + '" name="min" value="' + (f.min.value != null ? f.min.value : '') + '" placeholder="0"></span></label>' +
            '<label><span>' + esc(T('to')) + '</span><span class="mcp-fprice__in">' + esc(cur) + '<input type="number" inputmode="numeric" min="0" max="' + f.range_max + '" name="max" value="' + (f.max.value != null ? f.max.value : '') + '" placeholder="' + f.range_max + '"></span></label>' +
            '<button type="submit" class="mcp-btn mcp-btn--sm">' + esc(T('apply')) + '</button></form>';
        } else {
          html = '<ul class="mcp-fvals">' + f.values.map(function (v, j) {
            var dis = !v.count && !v.active;
            return '<li><label class="' + (dis ? 'is-dis' : '') + '"><input type="checkbox" data-p="' + esc(f.param) + '" value="' + esc(v.value) + '"' + (v.active ? ' checked' : '') + (dis ? ' disabled' : '') + '><span class="mcp-fvals__box" aria-hidden="true"></span><span class="mcp-fvals__l">' + esc(v.label) + '</span><small>' + v.count + '</small></label></li>';
          }).join('') + '</ul>';
        }
        panel.innerHTML = html;
        panel.hidden = false;
        var btn = bar.querySelector('[data-i="' + openIdx + '"]');
        if (btn) panel.style.top = (btn.offsetTop + btn.offsetHeight + 8) + 'px';
        if (btn && window.matchMedia('(min-width: 750px)').matches) {
          var left = btn.getBoundingClientRect().left - fbox.getBoundingClientRect().left;
          var max = fbox.clientWidth - panel.offsetWidth;
          panel.style.left = Math.max(0, Math.min(left, max)) + 'px';
        } else { panel.style.left = ''; }
        if (f.type === 'price') {
          panel.querySelector('form').addEventListener('submit', function (e) {
            e.preventDefault();
            var mn = this.elements.min.value, mx = this.elements.max.value;
            price = {};
            if (mn !== '') price[f.min.param] = mn;
            if (mx !== '') price[f.max.param] = mx;
            close(); apply();
          });
        }
      }

      function close() { if (openIdx === -1) return; openIdx = -1; renderPanel(); renderBar(); }

      function apply() {
        var url = urlFor();
        var my = ++req;
        grid.setAttribute('aria-busy', 'true');
        state.url = url;
        getFeed(url).then(function (data) {
          if (my !== req) return;
          if (data.facets) { syncFrom(data.facets); renderBar(); if (openIdx > -1) renderPanel(); }
          var total = data.total || data.cards.length;
          state.total = total;
          state.exhausted = data.cards.length <= initial;
          cards().forEach(function (c) { c.remove(); });
          var old = grid.querySelector('.mcp-empty'); if (old) old.remove();
          var list = data.cards.map(function (c) { return document.importNode(c, true); });
          list.slice(0, initial).forEach(insertCard);
          state.pool = list.slice(initial);
          if (!list.length) {
            var em = document.createElement('p'); em.className = 'mcp-empty'; em.textContent = T('none');
            grid.insertBefore(em, grid.querySelector('.mcp-note, [data-mcp-count]'));
          }
          setAllLinks(url, total);
          grid.removeAttribute('aria-busy');
          clipMobile();
          updateFoot();
        }).catch(function () { window.location.href = url; });
      }

      bar.addEventListener('click', function (e) {
        var b = e.target.closest('[data-i]'); if (!b) return;
        var i = parseInt(b.getAttribute('data-i'), 10);
        openIdx = openIdx === i ? -1 : i;
        renderBar(); renderPanel();
        if (openIdx > -1) { var first = panel.querySelector('input:not([disabled])'); if (first) first.focus({ preventScroll: true }); }
      });
      panel.addEventListener('change', function (e) {
        var cb = e.target; if (!cb.matches('input[type=checkbox]')) return;
        var p = cb.getAttribute('data-p');
        var arr = sel[p] || [];
        if (cb.checked) { if (arr.indexOf(cb.value) < 0) arr.push(cb.value); } else { arr = arr.filter(function (v) { return v !== cb.value; }); }
        if (arr.length) sel[p] = arr; else delete sel[p];
        apply();
      });
      activeBox.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        if (b.hasAttribute('data-clear-all')) { sel = {}; price = {}; }
        else if (b.hasAttribute('data-clear-price')) { price = {}; }
        else {
          var p = b.getAttribute('data-p'), v = b.getAttribute('data-v');
          if (sel[p]) { sel[p] = sel[p].filter(function (x) { return x !== v; }); if (!sel[p].length) delete sel[p]; }
        }
        close(); apply();
      });
      document.addEventListener('click', function (e) {
        if (openIdx === -1) return;
        var path = e.composedPath ? e.composedPath() : [e.target];
        if (path.indexOf(fbox) > -1) return;
        close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && openIdx > -1) { var i = openIdx; close(); var b = bar.querySelector('[data-i="' + i + '"]'); if (b) b.focus(); }
      });

      function boot() {
        getFeed(base).then(function (data) {
          syncFrom(data.facets);
          if (!facets.length) { fbox.hidden = true; return; }
          renderBar();
        }).catch(function () { fbox.hidden = true; });
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); boot(); }
        }, { rootMargin: '600px 0px' });
        io.observe(sec);
      } else { boot(); }
    }

    // Toon meer
    if (loadBtn) {
      loadBtn.addEventListener('click', function () {
        var hidden = cards().filter(function (c) { return c.hidden; });
        if (hidden.length) {
          hidden.slice(0, STEP).forEach(function (c) { c.hidden = false; });
          updateFoot();
          return;
        }
        loadBtn.setAttribute('aria-busy', 'true');
        var p = state.pool ? Promise.resolve(state.pool) : getFeed(state.url).then(function (data) {
          var have = {};
          cards().forEach(function (c) { have[c.getAttribute('data-handle')] = 1; });
          if (data.total) state.total = data.total;
          return data.cards.filter(function (c) { return !have[c.getAttribute('data-handle')]; })
            .map(function (c) { return document.importNode(c, true); });
        });
        p.then(function (pool) {
          var room = Math.max(0, CAP - visibleCount());
          var take = pool.slice(0, Math.min(STEP, room));
          take.forEach(insertCard);
          state.pool = pool.slice(take.length);
          if (!state.pool.length) state.exhausted = true;
          loadBtn.removeAttribute('aria-busy');
          updateFoot();
          if (take[0]) { var l = take[0].querySelector('a'); if (l) l.focus({ preventScroll: true }); }
        }).catch(function () {
          loadBtn.removeAttribute('aria-busy');
          window.location.href = state.url;
        });
      });
    }

    // Swipe-rij pijltjes
    var rail = sec.querySelector('[data-mcp-rail]');
    if (rail) {
      var prev = sec.querySelector('[data-mcp-prev]');
      var next = sec.querySelector('[data-mcp-next]');
      var sync = function () {
        if (prev) prev.disabled = rail.scrollLeft < 8;
        if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 8;
      };
      var go = function (dir) { rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: 'smooth' }); };
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      rail.addEventListener('scroll', sync, { passive: true });
      sync();
    }

    if (isMobile.addEventListener) isMobile.addEventListener('change', clipMobile);
    clipMobile();
    updateFoot();
  }

  // Feedback bij toevoegen. UpCart vangt het formulier zelf af en opent de winkelwagen.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-mcp-add]')) return;
    var btn = form.querySelector('button');
    if (!btn) return;
    btn.classList.add('is-busy');
    setTimeout(function () {
      btn.classList.remove('is-busy');
      btn.classList.add('is-added');
    }, 500);
  }, true);


  // Hotspots: tik op een stip opent een klein productkaartje; buiten klikken of Esc sluit.
  function closeHs(except) {
    document.querySelectorAll('[data-mcp-hs-dot][aria-expanded="true"]').forEach(function (d) {
      if (d === except) return;
      d.setAttribute('aria-expanded', 'false');
      var p = document.getElementById(d.getAttribute('aria-controls'));
      if (p) p.hidden = true;
    });
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('[data-mcp-hs-dot]');
    if (dot) {
      e.preventDefault();
      var open = dot.getAttribute('aria-expanded') === 'true';
      closeHs(dot);
      dot.setAttribute('aria-expanded', open ? 'false' : 'true');
      var pop = document.getElementById(dot.getAttribute('aria-controls'));
      if (pop) pop.hidden = open;
      return;
    }
    if (!(e.target.closest && e.target.closest('.mcp-hs__pop'))) closeHs();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeHs(); });

  function boot() { document.querySelectorAll('[data-mcp]').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
